import { render, staticRenderFns } from "./JcReport.vue?vue&type=template&id=4d4b0107&scoped=true"
import script from "./JcReport.vue?vue&type=script&lang=js"
export * from "./JcReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4b0107",
  null
  
)

export default component.exports